import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import HiddenSeoTime, { VisibleSeoTime } from '../../../../../common/seoUpdateTime';

class TitleLine extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    formatDateTime = (newsTime) => {
        if (!newsTime || typeof newsTime !== 'string') {
            return newsTime || '';
        }

        const parts = newsTime.split(' ');
        const date = parts[0] || '';
        const time = parts[1] || '';
        const dateParts = date.split('-');

        if (dateParts.length < 3) {
            return newsTime;
        }

        return `${dateParts[0]}年${dateParts[1]}月${dateParts[2]}日 ${time}`.trim();
    };

    render() {
        const { content = {} } = this.props;
        const {
            title = '',
            newsTime = '',
            updateTime = '',
            subscribe = {},
            hasCopyRight = false,
        } = content;
        const authorUrl = !subscribe.forbidJump && subscribe.authorUrl ? subscribe.authorUrl : 'javascript:;';
        const isShowFollowButton = subscribe?.forbidFollow === 0;
        const dateTime = this.formatDateTime(newsTime);
        const publishTime = newsTime;

        return (
            <header className={styles.titleLine}>
                <h1 className={styles.topic}>{title}</h1>
                <div className={styles.info}>
                    <div className={styles.infoboxLink}>
                        {subscribe.logo ? (
                            <div className={styles.face}>
                                <a href={authorUrl}>
                                    <img className={styles.faceImg} src={subscribe.logo} alt="" />
                                    {subscribe.honorImg ? (
                                        <img src={subscribe.honorImg} className={styles.faceV} alt="" />
                                    ) : null}
                                </a>
                            </div>
                        ) : null}
                        <div className={styles.textTitle}>
                            <div className={styles.sourceTitle}>
                                <div className={styles.sourceTitleText}>
                                    <a href={authorUrl} rel="medianame">
                                        {subscribe.catename || subscribe.weMediaName || ''}
                                    </a>
                                </div>
                                {hasCopyRight && isShowFollowButton ? (
                                    <div className={styles.follow}>
                                        <img
                                            className={styles.followPicBtn}
                                            src="https://x0.ifengimg.com/ucms/2022_05/F0CA5364C2EE44D3C30EB63ED29990CDE86D9D3F_size3_w100_h40.png"
                                            alt=""
                                        />
                                        <div className={styles.followBox}>
                                            <img
                                                className={styles.followPic}
                                                src="https://x0.ifengimg.com/ucms/2022_05/20B903E4FDFBB2BFE6240FC545BD87FBA9243DC1_size26_w1000_h1000.png"
                                                alt=""
                                            />
                                            <div className={styles.followText}>
                                                下载客户端
                                                <br />
                                                独家抢先看
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            <div className={styles.timeBref}>
                                <a href={authorUrl}>
                                    <VisibleSeoTime publishTime={publishTime}>{dateTime}</VisibleSeoTime>{' '}
                                    {subscribe?.lastArticleAddress || ''}
                                </a>
                                <HiddenSeoTime publishTime={publishTime} updateTime={updateTime} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.devide} />
            </header>
        );
    }
}

export default errorBoundary(TitleLine);
